import { render } from "./d-card-result.vue?vue&type=template&id=ca07ab16&scoped=true&ts=true"
import script from "./d-card-result.vue?vue&type=script&lang=ts"
export * from "./d-card-result.vue?vue&type=script&lang=ts"

import "./d-card-result.vue?vue&type=style&index=0&id=ca07ab16&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca07ab16"]])

export default __exports__